import { DeepReadonly } from 'utility-types';
import { ISubsidiariesOrganization, IUserOrganization } from '../interfaces/userOrganization';

export const flattenSubsidiariesHierarchy = (subsidiariesHierarchy: ISubsidiariesOrganization) => {
  const organizations: ISubsidiariesOrganization[] = [];

  organizations.push(subsidiariesHierarchy);
  subsidiariesHierarchy.children
    .slice()
    .sort((a: ISubsidiariesOrganization, b: ISubsidiariesOrganization) =>
      a.organizationName.localeCompare(b.organizationName)
    )
    .forEach((child: ISubsidiariesOrganization) => {
      organizations.push(...flattenSubsidiariesHierarchy(child));
    });

  return organizations;
};

export const getCurrentOrganizationInHierarchy = (
  userOrganizations: DeepReadonly<IUserOrganization[]>,
  organizationId: string
): ISubsidiariesOrganization | undefined =>
  userOrganizations
    .flatMap(organization =>
      flattenSubsidiariesHierarchy(organization.subsidiariesHierarchy as ISubsidiariesOrganization)
    )
    .find(organization => organization.organizationId === organizationId);

export const hasSubsidiaries = (
  userOrganizations: DeepReadonly<IUserOrganization[]>,
  organizationId: string
): boolean => {
  const organization = getCurrentOrganizationInHierarchy(userOrganizations, organizationId);

  return organization?.children.length! > 0;
};
